import { Component, OnInit, Inject, Optional } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppState } from '../../../../../../store/reducers';
import { Store } from '@ngrx/store';
import { AlertService } from '../../../../../../commons/services/alert.service';
import { Coupons } from '../../../../../../commons/models/coupons';
import * as CouponsActions from "../../../../../../store/actions/coupons.actions"

@Component({
  selector: 'app-new-coupons',
  templateUrl: './new-coupons.component.html',
  styleUrls: ['./new-coupons.component.scss']
})
export class NewCouponsComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  couponsForm: UntypedFormGroup;
  private _coupon: Coupons;

  constructor(
    private store$: Store<AppState>,
    private alertService: AlertService,
    private fb: UntypedFormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.data) {
      this.coupon = this.data.coupon;
    }

    this._createForm();
    this.ngOnChanges();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private _createForm() {
    this.couponsForm = this.fb.group({
      name: [""],
      code: ["", Validators.required],
      startDate: ["", Validators.required],
      endDate: ["", Validators.required],
      type: ["fixed", Validators.required],
      discount: ["", Validators.required],
      minimumOrderAmount: ["", Validators.required],
      maximumOrderAmount: ["", Validators.required],
      maxUsesPerUser: ["", Validators.required],
    });
  }

  private ngOnChanges() {
    if (this.couponsForm) {
      this.couponsForm.reset();
      
      this._initFormValues(this.coupon);
    }
  }

  private _initFormValues(coupon?: Coupons) {
    if (coupon) {
      this.couponsForm.patchValue({
        name: coupon.name,
        code: coupon.code,
        startDate: coupon.startDate,
        endDate: coupon.endDate,
        type: coupon.type,
        discount: coupon.discount,
        minimumOrderAmount: coupon.minimumOrderAmount,
        maximumOrderAmount: coupon.maximumOrderAmount,
        maxUsesPerUser: coupon.maxUsesPerUser,
      });
    } else {
      this.couponsForm.markAllAsTouched();
    }
  }

  private _prepareSaveCoupon(): Coupons {
    return Coupons.fromFormGroup(this.couponsForm, this.coupon);
  }

  save() {
    let unsavedCoupon = this._prepareSaveCoupon();
    this.store$.dispatch(CouponsActions.saveCoupon({ coupon: unsavedCoupon }));
  }

  close() {
      if (this.couponsForm.dirty) {
      // Se ci sono modifiche, mostra il dialog di conferma
        this.store$.dispatch(CouponsActions.requestCloseCouponsDialog());
      } else {
      // Se il form è pristine (nessuna modifica), chiudi
        this.store$.dispatch(CouponsActions.closeCouponsDialog());
      }  
    }

  deleteCoupon() {
    if (this.coupon) {
      this.store$.dispatch(CouponsActions.deleteCoupon({ coupon: this.coupon.toDTO() }));
    }
  }

  revert() {
    this.ngOnChanges();
  }

  get coupon(): Coupons {
    return this._coupon;
  }

  set coupon(coupon: Coupons) {
    this._coupon = coupon;
    this.ngOnChanges();
  }
}
